/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';
import { useErrorBoundary } from 'preact/hooks';

// Core
import RouterComponent from '@client/services/router/components/router';

// App
import Analytics from '@/client/services/metrics/Component';

/*----------------------------------
- TYPES
----------------------------------*/

/*----------------------------------
- LAYOUT
----------------------------------*/
import './index.less';
export default ({ data, user, api, Router, toast, modal, context, app, request, page }) => {

    /*----------------------------------
    - INIT
    ----------------------------------*/


    /*----------------------------------
    - ACTIONS
    ----------------------------------*/ 
    

    /*----------------------------------
    - RENDER
    ----------------------------------*/
    return <>
        <Analytics />
        <div id="layout" class="convert col">
            <RouterComponent service={Router} />
        </div>
    </>
}